import ArmProvider from './arm-data-provider';
import Constants from '../../utils/constants';
export async function listTenants(accessToken, locale, language) {
    const response = await ArmProvider.get(Constants.Urls.Tenants, accessToken, locale, language);
    const tenantResponse = response && response.json ? (await response.json()) : undefined;
    let tenants = tenantResponse && tenantResponse.value ? tenantResponse.value : [];
    tenants = tenants.filter((o) => !!o.displayName);
    return tenants;
}
